import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined'
import { IconButton, Typography, MenuList } from '@material-ui/core'

import { copyToClipboard } from 'libs/clipboard'

import Menus from 'app/componentV4/Menu/Menus'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'
import MessageAlert from 'app/components/MessageAlert'
import Circular from 'app/componentV4/Loader/Circular'

import usePublicLink from './usePublicLinkAction'
import { CopyIcon } from 'app/components/icons'

const useStyles = makeStyles((theme) => ({
  tooltip: {
    fontWeight: 'bolder',
    fontSize: '12px',
  },
  menus: {
    '& .MuiPaper-root': {
      padding: 0,
      width: '220px',
      maxHeight: '245px',
      overflow: 'scroll',
      borderRadius: '4px',
      '& .MuiMenu-list': {
        padding: '0',
      },
    },
    '& .share-public-header': {
      backgroundColor: theme.colors.white,
      color: theme.colors['primary'],
      padding: '1rem',
      position: 'fixed',
      fontSize: '14px',
      fontWeight: 400,
      width: '220px',
      borderRadius: '4px 4px 0 0',
      zIndex: 9999,
    },
    '& .share-public-item': {
      color: theme.colors['primary'],
      padding: '1rem',
      cursor: 'pointer',
      display: 'flex',
      fontSize: '14px',
      alignItems: 'center',
      fontWeight: 400,
      justifyContent: 'space-between',
      '&:hover': {
        backgroundColor: theme.colors['primary-200'],
      },
    },
  },
}))

const PublicLinkAction = (props) => {
  const { id, isSharingEnabled = false } = props
  const { formatMessage } = useIntl()
  const classes = useStyles()
  const dispatch = useDispatch()

  const {
    state: { isLoading, publicList },
    fetchPublickList,
  } = usePublicLink(id)

  const [anchorEl, setAnchorEl] = useState(null)

  const openMenu = (event) => {
    fetchPublickList()
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  function closeMenu(event) {
    event.stopPropagation()
    setAnchorEl(null)
  }

  const handleCopyLink = (link) => {
    copyToClipboard(link)
      .then(() => {
        dispatch(
          MessageAlert.showSuccess({
            message: formatMessage({
              id: 'notificationTimeline.card.publicLink.shareAlert.copySucceed',
            }),
          }),
        )
      })
      .catch(() => {
        dispatch(
          MessageAlert.showError({
            message: formatMessage({
              id: 'notificationTimeline.card.publicLink.shareAlert.copyFailure',
            }),
          }),
        )
      })
  }

  return (
    <>
      {isSharingEnabled && (
        <PrimaryTooltip
          title={formatMessage({
            id: 'notificationTimeline.card.publicLink.shareButton.title',
          })}
        >
          <IconButton
            className="text-primary"
            aria-owns={anchorEl ? 'share-public-link' : null}
            aria-haspopup="true"
            size="small"
            onClick={openMenu}
          >
            <ShareOutlinedIcon fontSize="small" className="text-primary" />
          </IconButton>
        </PrimaryTooltip>
      )}

      <Menus
        id="share-public-link"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        className={classes.menus}
      >
        <MenuList className="share-public-header border-b border-primary-350">
          {formatMessage({ id: 'timeline.share.public.link' })}
        </MenuList>
        {isLoading ? (
          <div className="flex justify-center pt-48">
            <Circular color="secondary" size={12} className="my-10" />
          </div>
        ) : (
          <div className="pt-48">
            {publicList.map((link) => (
              <MenuList
                key={`${link.id}-lang`}
                className="share-public-item"
                onClick={(event) => {
                  handleCopyLink(link.publicLink)
                  closeMenu(event)
                }}
              >
                <div>
                  <Typography className="text-12">{link.name}</Typography>
                  <Typography className="text-12">{link.nativeName}</Typography>
                </div>
                <CopyIcon fill="#183560" />
              </MenuList>
            ))}
          </div>
        )}
      </Menus>
    </>
  )
}

PublicLinkAction.propTypes = {
  id: PropTypes.number,
}
export default PublicLinkAction
